console.log("inside app.js");

// const anim_els = document.querySelectorAll(".transition");

// observe_element(anim_els, 750, "33%", false);








